import React from "react";
import img from "../../resources/logo.webp";
import "./style.css";
import StepperAppointments from "../../common/stepper-appointments/StepperAppointments";

export const AdminAppointments = () => {
    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>
            <h1>Pregled termina</h1>
            <StepperAppointments />
            <div className='barber-zajednica-admin-logo'>
                <img src={img} alt='Barber Zajednica Logo' />
            </div>
        </div>
    );
};
